import { defineStore } from 'pinia'
import { localCache } from '@/utils/comm'
import { KL_THEME } from '@/global/constants.ts'
interface IThemeState {
  theme: string
}

const useThemeStore = defineStore('theme', {
  state: (): IThemeState => ({
    theme: localCache.getCache(KL_THEME) || 'light'
  }),
  actions: {
    actionInitTheme() {
      let curtTheme = this.theme
      switch (curtTheme) {
        case 'dark':
          document?.body?.setAttribute?.('arco-theme', 'dark')
          break
        case 'light':
          document?.body?.removeAttribute?.('arco-theme')
          break
        default:
          document?.body?.removeAttribute?.('arco-theme')
          break
      }
    },
    // 保存提报信息
    // 'dark' | 'light'
    actionSetTheme(theme: string) {
      localCache.setCache(KL_THEME, theme)
      this.theme = localCache.getCache(KL_THEME) ?? 'light'
      this.actionInitTheme()
    }
  }
})

export default useThemeStore
